export default function middlewarePipeline(middleware, context) {
    const next = value => value ?? false

    for (let mw of middleware) {
        const nextValue = mw({ to: context.to, from: context.from, next })
        if (nextValue) return context.next(nextValue)
    }

    return context.next()
}